import {AuditPlanPageId, EngagementId} from "platformed-client/types";
import {HTTPError} from "platformed-client";
import api from "../../../api";
import {param, typedQuery} from "../../typing";

export const engagementAuditPlan = typedQuery(
  ["tprm", "engagementAuditPlan", param<EngagementId>("engagementId")],
  async engagementId => {
    try {
      return await api.tprm.auditPlans.get(engagementId);
    } catch (ex) {
      if (ex instanceof HTTPError && ex.response.status === 404) {
        return null;
      }
      throw ex;
    }
  },
);

export const auditPlanPageActivityStreamRefs = typedQuery(
  ["tprm", "auditPlanPageActivityStreamRefs", param<EngagementId>("engagementId"), param<AuditPlanPageId>("pageId")],
  async (engagementId, pageId) => {
    return await api.tprm.auditPlans.listPageActivityStreamRefs(engagementId, pageId);
  },
);

export const engagementAuditAreas = typedQuery(
  ["tprm", "engagementAuditAreas", param<EngagementId>("engagementId")],
  async engagementId => {
    return await api.tprm.auditPlans.listAuditAreas(engagementId);
  },
);

export const auditAreas = typedQuery(["tprm", "auditAreas"], async () => {
  return await api.tprm.auditPlans.listAllAuditAreas();
});

export const engagementProcessCandidates = typedQuery(
  ["tprm", "engagementProcessCandidates", param<EngagementId>("engagementId")],
  async engagementId => {
    return await api.tprm.auditPlans.listProcessCandidates(engagementId);
  },
);

// Every page's reviewers for the plan sidebar, fetched in one request. Keyed under the
// "engagementAuditPlan" namespace so the existing `q.tprm.engagementAuditPlan.filter(engagementId)`
// invalidation (fired when reviewers change) refreshes it too — it matches by key prefix.
export const engagementAuditPlanReviewables = typedQuery(
  ["tprm", "engagementAuditPlan", param<EngagementId>("engagementId"), "reviewables"],
  async engagementId => {
    return await api.tprm.auditPlans.listReviewables(engagementId);
  },
);
